<template>
	<div>
		<div class="container">
			<div class="form-box">
				<el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize"
					status-icon>
					<!-- 请选择组织 -->
					<!-- <el-form-item label="选择组织" prop="choose">
          <el-input v-model="form.choose" readonly   placeholder="请选择所属组织" @click="visible = true"></el-input>
        </el-form-item> -->
					<!-- 是否开启缴费 -->
					<el-form-item label="是否开启缴费" prop="genre">
						<el-select v-model="form.genre" placeholder="请选择是否开启缴费">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 缴费类型 -->
					<el-form-item label="缴费类型" prop="name">
						<el-select v-model="form.name" placeholder="请选择缴费类型">
							<el-option label="按月" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="按年" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 微信商户号 -->
					<!-- <el-form-item label="微信商户号" prop="name">
           <el-input v-model="form.name"  placeholder="请填写微信商户号"></el-input>
        </el-form-item> -->
					<!-- 商户支付KEY -->
					<!-- <el-form-item label="商户支付KEY" prop="payment">
           <el-input v-model="form.payment"  placeholder="请填写商户支付KEY"></el-input>
        </el-form-item> -->
					<!-- 缴费说明 -->
					<el-form-item label="缴费说明" prop="remark">
						<el-input type="textarea" v-model="form.remark" placeholder="请填写缴费说明"></el-input>
					</el-form-item>
					<!-- 提交按钮 -->
					<div class="submit">
						<el-form-item>
							<el-button type="primary" :loading="loa" @click="onSubmit">提交</el-button>
						</el-form-item>
					</div>
					<div>
						<s3-layer v-model="visible" title="所属组织" :shadeClose="true" :area="['500px', '80vh']"
							@yes="yes">
							<el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
						</s3-layer>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		ref,
		reactive,
		onMounted,
		onActivated
	} from "vue";
	import {
		ZClist,
		HFpreserve,
		HFdatabase
	} from '../../utils/api'
	import {
		ElMessage
	} from "element-plus";
	import qs from 'qs'
	import {
		useRouter,
		useRoute
	} from "vue-router";
	import {
		useStore
	} from "vuex";
	export default {
		name: "HFruledit",
		setup() {
			const route = useRoute();
			// 获取编辑数据 form.genre
			const list = () => {
				let data = {
					ruleId: sessionStorage.getItem('HFruledit')
				}
				HFdatabase(qs.stringify(data)).then((res) => {
					console.log(res)

					if (res.data.code == 0) {
						// 缴费说明
						form.remark = res.data.data.ruleInfo.payExplain
						// 是否开启缴费
						if (res.data.data.ruleInfo.isPay == 1) {
							form.genre = '是'
						} else if (res.data.data.ruleInfo.isPay == 2) {
							form.genre = '否'
						}
						// 缴费类型
						if (res.data.data.ruleInfo.payYearOrMonth == 1) {
							form.name = '按月'
						} else if (res.data.data.ruleInfo.payYearOrMonth == 2) {
							form.name = '按年'
						}
					}
				})
			}
			let translate = ref(2)
			onActivated(() => {
				translate.value = route.params.UserId
				if (translate.value == 1) {
					list()
				}
			})
			onMounted(() => {
				list()
				// messge()
			})
			// 获取工会列表信息
			const messge = () => {
				ZClist().then((res) => {
					console.log(res)
					texture.value = res.data.data.manageUnionList
				})
			}
			// 所属工会选择
			const yes = () => {
				form.choose = options.value
				visible.value = false;
			};
			// 获取工会code
			let gaincode = ref('')
			// 树形选择
			let options = ref('')
			let dendrogram = (node) => {
				options.value = node.unionName
				form.choose = options.value
				gaincode.value = node.unionCode
			}
			const defaultProps = {
				children: 'unionDtoList',
				label: 'unionName',
			}
			let texture = ref([])
			const visible = ref(false);
			// 表单内容
			const ruleFormRef = ref(null)
			const form = reactive({
				name: "",
				genre: "",
				choose: "",
				// payment:"",
				remark: ""
			})
			// 是否开启缴费
			let sincerely = ref(null)
			// 缴费类型
			let universe = ref(null)
			// 表单提交
			// 关闭当前页
			const store = useStore();
			const current = ref('')
			const expression = ref([])
			const Indexs = ref(null)


			const router = useRouter();
			const loa = ref(false)
			const onSubmit = () => {
				// router.push({ name: 'HFregulation', params: { userId: 1 }});
				// loa.value=true
				// 表单校验
				ruleFormRef.value.validate((valid) => {
					// 是否开启缴费
					if (form.genre == '是') {
						sincerely.value = 1
					} else if (form.genre == '否') {
						sincerely.value = 2
					} else if (form.genre == 1) {
						sincerely.value = 1
					} else if (form.genre == 2) {
						sincerely.value = 2
					}
					// 缴费类型
					if (form.name == '按月') {
						universe.value = 1
					} else if (form.name == '按年') {
						universe.value = 2
					} else if (form.name == 1) {
						universe.value = 1
					} else if (form.name == 2) {
						universe.value = 2
					}
					if (valid == true) {
						console.log('是否开启缴费', sincerely.value)
						console.log('缴费类型', universe.value)
						console.log('缴费说明', form.remark)
						let data = {
							"ruleId": sessionStorage.getItem('HFruledit'),
							"isPay": sincerely.value,
							"payYearOrMonth": universe.value,
							"payExplain": form.remark
						}
						HFpreserve(qs.parse(data)).then((res) => {
							console.log(res)
							if (res.data.code == 0) {
								ElMessage({
									message: "提交成功",
									type: "success",
									center: true,
								});
								setTimeout(() => {
									current.value = route.path
									expression.value = store.state.tagsList

									expression.value.forEach((item, index) => {
										if (current.value == item.path) {
											Indexs.value = index
										}
									})
									store.state.tagsList.splice(Indexs.value, 1)
									router.push({
										name: 'HFregulation',
										params: {
											userId: 1
										}
									});
									loa.value = false
								}, 500)
							} else {
								ElMessage({
									message: res.data.msg,
									type: "error",
									center: true,
								});
								loa.value = false
							}
						})
						// console.log('成功')
					} else if (valid == false) {
						ElMessage({
							message: "提交失败",
							type: "error",
							center: true,
						});
						loa.value = false
					}
				})
			}
			// 验证表单提示
			const rules = {
				name: [{
					required: true,
					message: "请选择缴费类型",
					trigger: "blur"
				}, ],
				genre: [{
					required: true,
					message: "请选择是否开启缴费",
					trigger: "blur"
				}, ],
				// choose:[
				//   { required: true, message: "请选择所属工会", trigger: "change" },
				// ],
				// payment:[
				//   { required: true, message: "请填写商户支付KEY", trigger: "change" },
				// ],
				// remark:[
				//   { required: true, message: "请填写备注", trigger: "change" },
				// ],
			}
			return {
				// 提交按钮
				loa,
				// 树形选择内容
				yes,
				visible,
				dendrogram,
				defaultProps,
				texture,
				// 表单内容
				ruleFormRef,
				form,
				// 表单提交按钮
				onSubmit,
				rules
			}
		},
	}
</script>>

<style lang='scss' scoped>
	::v-deep .el-form-item__label {
		width: 108px;
	}

	::v-deep .el-form-item__label {
		font-weight: bold;
	}

	::v-deep .el-button {
		width: 100px;
		height: 40px;
		font-size: 16px;
	}

	::v-deep .submit {
		margin-left: 80px;
	}

	::v-deep .el-input {
		height: 44px;
	}

	::v-deep .el-form-item {
		margin-bottom: 30px;
		align-items: center;
	}

	::v-deep .el-tree-node__content {
		font-weight: 500;
	}

	::v-deep .el-select-dropdown__item.hover {
		background-color: #ffffff;
	}

	::v-deep .el-select-dropdown__wrap {
		background-color: #ffffff;
	}

	::v-deep .form-box {
		width: 500px;
	}

	::v-deep .el-form-item__content {
		margin-left: 0 !important;
	}

	::v-deep .container {
		max-width: 91%;
		margin: auto;
		margin-top: 10px;
		padding: 30px;
		background: #fff;
		border: 1px solid #ddd;
		border-radius: 5px;
	}
</style>